export function stringify(obj: unknown): string {
  if (obj instanceof URLSearchParams) {
    return stringify(Object.fromEntries(obj));
  }

  let s: string;
  try {
    s = JSON.stringify(obj);
  } catch (_error) {
    return `JSON.stringify failed ${obj}`;
  }

  s = s.replace(/\\"/g, "\uFFFF"); // escape internal quotes
  for (let i = 0; i < 3; ++i) {
    s = s.replace(/"([^"]+)":(null|undefined|\{\}),?/g, ""); // compact
  }
  s = s.replace(/,"(?!:)/g, '," '); // add space after comma
  s = s.replace(/"([^"]+)":/g, "$1: "); // remove quotes around keys
  s = s.replace(/\uFFFF/g, '\\"'); // restore escaped quotes
  return s;
}
